"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NearbyCommuteMethods = void 0;
var NearbyCommuteMethods;
(function (NearbyCommuteMethods) {
    NearbyCommuteMethods[NearbyCommuteMethods["WALKING"] = 0] = "WALKING";
    NearbyCommuteMethods[NearbyCommuteMethods["BUS"] = 1] = "BUS";
    NearbyCommuteMethods[NearbyCommuteMethods["DRIVE"] = 2] = "DRIVE";
})(NearbyCommuteMethods = exports.NearbyCommuteMethods || (exports.NearbyCommuteMethods = {}));
